import cns from 'classnames'
import { InfoFieldValue } from 'shared/ui/common/InfoFieldValue'
import { DashboardRow } from 'shared/ui/common/DashboardRow'

import { getPoolAssetIcon, PoolAsset } from 'modules/pools/constants/poolAssets'
import { formatAsset } from 'modules/pools/utils/formatAsset'
import { Tooltip } from 'shared/ui/common/Tooltip'
import {
  getApyTooltipText,
  getPoolShortLabelByRisk,
  PoolRisk,
} from 'modules/pools/constants/PoolRisk'
import * as links from 'modules/router/links'
import { Button } from 'shared/ui/controls/Button'
import { useTargetRiskPoolModal } from '../TargetRiskPoolModal/useTargetRiskPoolModal'

import { ReactComponent as QuestionMarkSvg } from 'assets/question-mark.svg'

import s from './DashboardRowDeposit.module.scss'

type Props = {
  apy: number
  risk: PoolRisk
  poolAddress: string
  depositedAmount: string | number
  accruedInterest: string | number | null
  depositedAsset: PoolAsset | undefined
  className?: string
}

export function DashboardRowDeposit({
  apy,
  risk,
  poolAddress,
  depositedAsset,
  depositedAmount,
  accruedInterest,
  className,
}: Props) {
  const targetRiskPoolModal = useTargetRiskPoolModal()
  return (
    <DashboardRow className={cns(s.root, className)}>
      <InfoFieldValue
        label="Asset"
        value={
          depositedAsset ? (
            <>
              {getPoolAssetIcon(depositedAsset)} {depositedAsset}
            </>
          ) : (
            'Unknown Asset'
          )
        }
      />
      <InfoFieldValue
        label={
          <div className={s.labelWithTooltip}>
            Pool
            <QuestionMarkSvg onClick={targetRiskPoolModal.open} />
          </div>
        }
        value={getPoolShortLabelByRisk(risk)}
      />
      <InfoFieldValue
        label="Amount"
        value={formatAsset(depositedAmount, depositedAsset)}
        sign={depositedAsset}
        tooltip={depositedAmount}
      />
      <InfoFieldValue
        label={
          <div className={s.labelWithTooltip}>
            Yield APY
            <Tooltip tooltip={getApyTooltipText(risk)} className={s.tooltip}>
              <QuestionMarkSvg />
            </Tooltip>
          </div>
        }
        value={`${apy.toFixed(2)}%`}
      />
      <InfoFieldValue
        label="Accrued interest"
        value={
          accruedInterest
            ? formatAsset(accruedInterest, depositedAsset)
            : 'Loading...'
        }
        sign={depositedAsset}
        tooltip={accruedInterest}
      />
      <Button
        link={links.withdrawalDeposit(poolAddress)}
        fashion="greenapple-ghost"
        size={40}
        testId="dashboard-deposit-withdraw-button"
      >
        WITHDRAW
      </Button>
    </DashboardRow>
  )
}
